import React from "react";
import PropTypes from "prop-types";
import { CircularProgress, IconButton } from "@mui/material";
import { Done, ErrorOutline, Sync } from "@mui/icons-material";

function SyncButton(props) {
  const [status, setStatus] = React.useState("INIT");

  return (
    <IconButton
      onClick={() => {
        setStatus("SYNCING");
        props
          .onClick()
          .then(() => {
            setStatus("DONE");
          })
          .catch(() => {
            setStatus("ERROR");
          });
      }}
    >
      {status === "INIT" ? (
        <Sync />
      ) : status === "SYNCING" ? (
        <CircularProgress color={"primary"} size={20} />
      ) : status === "ERROR" ? (
        <ErrorOutline />
      ) : status === "DONE" ? (
        <Done />
      ) : (
        <Sync />
      )}
    </IconButton>
  );
}

SyncButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default SyncButton;
